import { Component, OnInit } from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ApiRestService} from "../api-rest.service";
import {ListinoImportComponent} from "../listino-import/listino-import.component";
import {Filter, Listino} from "../_Models";
import {Permission} from "../../Login/_guards/Permission";
import {ServerPaginationService} from "../../shared/_services/server-pagination.service";
import {ListinoEditComponent} from "../listino-edit/listino-edit.component";
import {ImportComponentComponent} from "../../shared/import-component/import-component.component";
import {ApiPathsService} from "../../api-paths.service";

@Component({
  selector: 'app-listini-list',
  templateUrl: './listini-list.component.html'
})
export class ListiniListComponent implements OnInit {
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server
  Lista: Listino[] = [];
  filtri: Filter = new Filter();
  collectionSize: number = 0;
  ShowAll: boolean = false;
  constructor(
    private modalService: NgbModal,
    private apiRestService: ApiRestService,
    public permission: Permission,
    private paginationService: ServerPaginationService,
    private apiPaths: ApiPathsService
  ) { }

  ngOnInit(): void {
    this.Refresh(1);
  }

  Refresh(page?: number){
    if(page) {
      this.filtri.page = (page - 1) / this.pagesizeserver + 1;
      this.filtri.size = this.pagesizeserver * this.pageSize;
    }
    this.apiRestService.ProdottiListinoList(this.filtri,this.ShowAll).subscribe(data=>{
      this.Lista = data.data;
      this.collectionSize = data.total;
    })
  }

  ImportaListini(){
    let modale = this.modalService.open(ListinoImportComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ListinoImportComponent>modale.componentInstance).Uploaded.subscribe(()=> {
      modale.dismiss();
      this.Refresh();
    });
  }

  AddListino() {
    let modale = this.modalService.open(ListinoEditComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ListinoEditComponent>modale.componentInstance).isModal = true;
    (<ListinoEditComponent>modale.componentInstance).listino = new Listino();
    (<ListinoEditComponent>modale.componentInstance).Saved.subscribe(()=> this.Refresh());
  }
  EditListino(item: Listino) {
    let modale = this.modalService.open(ListinoEditComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ListinoEditComponent>modale.componentInstance).isModal = true;
    (<ListinoEditComponent>modale.componentInstance).listino = item;
    (<ListinoEditComponent>modale.componentInstance).Saved.subscribe(()=> this.Refresh());
  }
  Delete(item: Listino) {
    if (confirm("Sei sicuro di voler eliminare questo elemento? "))
      this.apiRestService.ProdottiListinoDelete(item).subscribe(() => this.Refresh());
  }
  Restore(item: Listino) {
    this.apiRestService.ProdottiListinoRestore(item).subscribe(() => this.Refresh());
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.filtri.page = (page - 1) / this.pagesizeserver + 1;
      this.filtri.size = this.pagesizeserver * this.pageSize;
      this.Refresh();
    }
  }

  Eliminati() {
    this.ShowAll = !this.ShowAll;
    this.Refresh(1)
  }

  ImportaDefault() {
    let modale = this.modalService.open(ImportComponentComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ImportComponentComponent>modale.componentInstance).Uploaded.subscribe(()=> {
      modale.dismiss();
      this.Refresh();
    });
    (<ImportComponentComponent>modale.componentInstance).updateSelectedUrl(this.apiPaths.getBaseAPI() + '/prodotti/aggiunte/default');
    (<ImportComponentComponent>modale.componentInstance).isModal = true;
  }
}
